import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import { useState, useReducer } from "react"
import { enumUtil } from "../../../../utils/Enum"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { useEffect } from "react"
import Loader from "../../../shared/Loader/Loader"
import Pagination from "../../../shared/Pagination/Pagination"
import AddNewSubmitter from "./AddNewSubmitter"
import SearchHeader from "../../Shared/SearchHeader"
import Card from "../../Shared/Card"
import Table from "../../Shared/Table"
import GridColumnHeader from "../../Shared/GridColumnHeader"
import handleCopyText from "../../../shared/CopyData"
import isNull from "../../../../utils/NullChecking"
import { connect } from "react-redux"
import Clearinghouses from "../../Shared/Clearinghouses"
import CMD from "../../../../assets/img/CMD.svg"
import OfficeAlly from "../../../../assets/img/office-ally.svg"
import FormValidator from "../../../../utils/FormValidator"
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import usePagination from "../../../../customhooks/usePagination"





const Submitter = (props) => {
    const API_URL = enumUtil.controller.General
    const API_URL_Integration = enumUtil.controller.Integration
    const { type, Settings } = { ...props }
    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);

    const [SubmitterID, setSubmitterID] = useState();
    const [searchParam, setSearchParam] = useState();
    const [IsOpenSubmitter, setIsOpenSubmitter] = useState(false);
    const [IsOpenClearHo, setIsOpenClearHo] = useState(false);
    const [SubmitterData, setSubmitterData] = useState([]);
    const [EnterParam, setEnterParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState();
    const [show, setShow] = useState(true);
    const [cardenable, setCardEnable] = useState(false)
    // const [cardData, setCarData] = useState([])
    const [disabled, setDisable] = useState(false)


    let ValidationModal = {
        POSCodeVal: "",
    }
    let valModal = {}

    const [POSValidationModal, setPOSValidationModal] = useState(ValidationModal)

    // const [show, setShow] = useState(Settings?.DefaultPageView === "Card View" ? true : false);

    const [totalCounts, setTotalCounts] = useState(false)
    const [copiedText, setCopiedText] = useState({});
    const searchButton = {
        AddNew: true,
        Excel: false,
        PDF: false,
        Delete: false,
        Filter: false,
        View: true,
        // clearHouseButton: true
    }

    const [CardData, setCardData] = useState([])

    let Claim_MD = {
        Professional: false,
        Institutional: false,
        Eligibility: false,
        ClaimStaus: false,
        // Disabled: false,
        AccountType: "",
    }

    const [mainClaimMDModel, setMainClaimMDModel] = useState(Claim_MD)

    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////
    //For Pagination
    // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    // const [PageNo, setPageNo] = useState(1);
    // const [TotalPages, setTotalPages] = useState();
    const [searchParamType, setSearchparamType] = useState("");
    // const handlePageClick = (page) => { setPageNo(page); }
    // const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    // const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    // const handleFingByCreteria = (e) => {
    //     setPerPage(e.target.value)
    //     setPageNo(1)
    // }
    // const handleSelectData = (data) => {
    //     setPerPage(data.value)
    //     setPageNo(1)
    // }
    ///////////
    const [viewcards, setViewCards] = useState(false)

    let AccountTypeDD = [
        { display: "StarAccount", value: "StarAccount" },
        { display: "SCFAAccount", value: "SCFAAccount" },
    ]

    const LoadData = (param, types) => {
        setIsLoading(true)
        // setSubmitterData([])
        if (types) {
            setSearchparamType(types)
        } else {
            setSearchparamType("")
        }
        const SearchPageNo = !param
        ServerRequestProtected(API_URL + "/GetSubmitter", 'post', {
            "TableName": enumUtil.enumAPITableName.SubmitterReceiver,
            "SearchParam": param,
            "PerPage": PerPage,
            "PageNo": SearchPageNo ? PageNo : 1,
        }).then((response) => {
            setTotalCounts(response.Rows.length)
            setIsLoading(false)
            if (response?.SubmitterCardView?.length > 0) {
                setViewCards(true)
                setDisable(true)
                setMainClaimMDModel(response?.SubmitterCardView?.[0])
            }
            else {
                setMainClaimMDModel(Claim_MD)

            }
            console.log(response, 'response ')

            handleGridHeader({ defaultData: response.Rows })
            setSubmitterData(response.Rows)
            setTotalPages(response.count.NumOfPages);
            if (type && type === "Wizard") {
                if (response.Rows?.length == 0 && isNull(searchParamType)) {
                    setIsOpenSubmitter(true)
                }
            }
        }).catch((error) => {
            setSubmitterData([])
            setTotalCounts(0)
            setMainClaimMDModel(Claim_MD)
            setIsLoading(false)
            if (type && type === "Wizard") {
                if (SubmitterData?.length == 0 && isNull(searchParamType)) {
                    setIsOpenSubmitter(true)
                }
            }
        })
    }
    // const LoadDataCard = (param, types) => {
    //     setIsLoading(true)
    //     ServerRequestProtected(API_URL + "/GetSubmitter", 'post', {
    //         "TableName": enumUtil.enumAPITableName.SubmitterReceiver,
    //         "SearchParam": param,
    //         "PerPage": PerPage,
    //         "PageNo": SearchPageNo ? PageNo : 1,
    //         // "PerPage": "50",
    //         // "PageNo": PageNo,
    //     }).then((response) => {
    //         setIsLoading(false)
    //         setCarData(response?.SubmitterCardView)
    //     }).catch((error) => {
    //         setIsLoading(false)
    //     })
    // }
    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            // setPageNo('1')
            LoadData(searchParam)
            // LoadDataCard(searchParam)
        } else {
            LoadData()
            // LoadDataCard()
        }
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam(searchParam, "searchParam")
        }
    }
    useEffect(() => {
        LoadData(searchParam);
        // LoadDataCard(searchParam)
    }, [PerPage, PageNo, isClose])

    const AddSubmitter = (ID) => {
        setIsOpenSubmitter(true)
        setSubmitterID(ID)
    }
    const CloseSubmitter = () => {
        setIsOpenSubmitter(false)
    }
    const CloseClearHo = () => {
        setIsOpenClearHo(false)
    }
    const DeleteSubmitter = () => {
        setIsOpenSubmitter(false)
        setIsClose((Math.random()));
    }
    const handleClearHousing = () => {
        setIsOpenClearHo(true)
    }
    let PopupScreen = "";
    if (IsOpenSubmitter) {
        PopupScreen = <AddNewSubmitter IsOpenSubmitter={IsOpenSubmitter} onClose={CloseSubmitter} onDeleteSubmitter={DeleteSubmitter} SubmitterID={SubmitterID} type={type} />
    }
    let PopupScreenClearHO = "";
    if (IsOpenClearHo) {
        PopupScreenClearHO = <Clearinghouses IsOpenClearHo={IsOpenClearHo} onClose={CloseClearHo} />
    }
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", name)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    const columns = [

        {
            key: 'ProfileName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Profile Name'} sortIcon={true} type={'string'} colKey={'ProfileName'} data={SubmitterData} setData={setSubmitterData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <button className="btn btn-link w-100 p-0" >
                        <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                            <div className="validation_message" onClick={() => AddSubmitter(row.SubmitterReceiverID)}>{row.ProfileName} </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.SubmitterReceiverID, row.ProfileName)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.SubmitterReceiverID}-${row.ProfileName}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </button>
                );
            },
        },
        {
            key: 'Submitter',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Submitter'} sortIcon={true} type={'string'} colKey={'Submitter'} data={SubmitterData} setData={setSubmitterData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.Submitter}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.SubmitterReceiverID, row.Submitter)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.SubmitterReceiverID}-${row.Submitter}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'SubmitterID',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Submitter ID'} sortIcon={true} type={'string'} colKey={'SubmitterID'} data={SubmitterData} setData={setSubmitterData} />),
            resizable: true,
        },
        {
            key: 'ReceiverName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Receiver'} sortIcon={true} type={'string'} colKey={'ReceiverName'} data={SubmitterData} setData={setSubmitterData} />),
            resizable: true,
        },
        {
            key: 'ExportFormat',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Format'} sortIcon={true} type={'number'} colKey={'ExportFormat'} data={SubmitterData} setData={setSubmitterData} />),
            resizable: true,
        },
        {
            key: 'CreatedDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Updated Date'} sortIcon={true} type={'string'} colKey={'CreatedDate'} data={SubmitterData} setData={setSubmitterData} />),
            flex: 1,
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            {row.CreatedDate}
                        </div>
                    </>
                );
            }
        },
    ]
    const CardView = () => setShow(true);
    const TableView = () => setShow(false);
    const rowClass = () => { return "row-bg" }
    const handleExcel = () => { }
    const handlePdf = () => { }
    const handleFilter = () => { }
    const handleDelete = () => { }

    const handleClaimMD = (e) => {
        let { name, checked, type, value, id } = e.target;
        let modal = { ...mainClaimMDModel };

        if (type === "checkbox") {
            modal[name] = checked
        }
        else if (type === "radio") {
            if (id === "SelfAccount") {
                modal[name] = "SelfAccount"
            }
            else if (id === "StarAccount") {
                modal[name] = "StarAccount"
            }
            else if (id === "SCFAAccount") {
                modal[name] = "SCFAAccount"
            }
        }
        setMainClaimMDModel(modal)

    }

    const handleSuperSearchChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainClaimMDModel };
        // let saveModal = { ...moreInfoSaveUpdateModal }
        // if (name === 'PrescriptionDate') {
        //     modal[name] = FormatedDate
        //     saveModal[name] = FormatedDate
        // } else {
        modal[name] = value
        setMainClaimMDModel(modal)
        // for (var property in MoreInfo_Modal) {
        //     if (name === property) {
        //         saveModal[name] = value
        //     }
        // }
        // setmoreInfoSaveUpdateModal(saveModal)
        // }
    }

    // console.log(mainClaimMDModel, 'mainmodel');

    const [accounttypedisplay, setAccountTypeDisplay] = useState()

    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainClaimMDModel };
        if (type === 'client' && !isNull(selectedData)) {
            setAccountTypeDisplay(selectedData.display)
            modal[name] = selectedData.value + "";
        } else if (type === 'server' && !isNull(selectedData)) {
        } else {
            modal[name] = ''
            mainClaimMDModel[name] = ''
        }
        setMainClaimMDModel(modal)
        return selectedData
    }

    const convertValuesToString = (data) => {
        const updatedModel = Object.fromEntries(
            Object.entries(data).map(([key, value]) => [key, value.toString()])
        );
        return updatedModel
    };

    // const POSValidation = async () => {
    //     let ValidationModal = {
    //         POSCodeVal: FormValidator(
    //             mainClaimMDModel.AccountType,
    //             enumUtil.enumValidationType.Required,
    //             'Account Type',
    //         )
    //     }
    //     await setPOSValidationModal(ValidationModal)
    //     valModal = ValidationModal
    // }
    const handleSaveClaimMD = async () => {
        const updatedData = { ...mainClaimMDModel };
        delete updatedData.SubmitterID;
        delete updatedData.ReceiverName;
        // setMainClaimMDModel(updatedData);


        if (mainClaimMDModel.AccountType === "") {
            NotificationHandler(' Please Select Account Type', enumUtil.enumtoaster.error)

        }
        else if (mainClaimMDModel.ClaimStatus === false && mainClaimMDModel.Eligibility === false && mainClaimMDModel.Institutional === false && mainClaimMDModel.Professional === false) {
            NotificationHandler(' Please Select Claim Type', enumUtil.enumtoaster.error)

        }
        // await POSValidation()
        // let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        // if (validation) {
        //     NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
        //     return
        // }

        else {
            let saveModal = {
                TableName: enumUtil.enumAPITableName.SubmitterIntegration,
                Main: [convertValuesToString(updatedData)],
                // Mian: [mainClaimMDModel],
                SubmitterReceiver: [{}],
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL_Integration + "/IntegrationSubmitter", 'post', saveModal)
                .then((response) => {
                    setIsLoading(false)
                    // setMainClaimMDModel({...mainClaimMDModel ,AccountType:""})
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                    LoadData(searchParam)
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    // setCarData([])

    const handleClearSearch = () => {
        setSearchParam('')
    }
    const SubmitterBody = () => {
        return (<>
            <div className={show ? 'container-fluid action-row br-bottom-1 br-clr' : 'container-fluid action-row br-clr'}>
                <div className="row justify-content-between">
                    <div className="col-4 form-rounded">
                        <div className="input">
                            <div className='input-group hk-input-search'>
                                <input type="text" className='form-control fc-xs'
                                    placeholder='Search by name or id…'
                                    onChange={e => setSearchParam(e.target.value)}
                                    onKeyDown={SearchOnEnter} value={searchParam} />
                                {searchParam?.length > 0 ?
                                    <span className="input-group-text" id="basic-addon2" onClick={handleClearSearch}>
                                        <i className="bi bi-x"></i>
                                    </span> : <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                        <i className="bi bi-search"></i>
                                    </span>}
                            </div>
                        </div>
                    </div>

                    <div className="col-8 ps-0">
                        <SearchHeader
                            AddNew={AddSubmitter}
                            Excel={handleExcel}
                            PDF={handlePdf}
                            // clearHouseButton = {handleClearHousing}
                            Delete={handleDelete}
                            Filter={handleFilter}
                            cardView={CardView}
                            tableView={TableView}
                            show={show}
                            searchButton={searchButton}
                            Key={624}
                            Name={'Submitter'}
                            Counts={totalCounts}
                        />
                    </div>
                </div>
            </div>
            {show ? (
                <>
                    {cardenable || viewcards ?


                        (

                            <>
                                <div div className='d-flex gap-40 flex-wrap submiterCard' >
                                    <div className='za-Claim-MD billing_to-do-list d-flex gap-20'>
                                        <div className='d-flex flex-column align-items-center'>
                                            <div className="mb-2 img-container s-60">
                                                <img src={CMD} />
                                            </div>
                                            <p className='heading fs-14 mb-06-px text-center'>{mainClaimMDModel?.ReceiverName}</p>
                                            <p className='text font-m fs-12 fst-italic text-center ar-border-color mb-06-px'>Submitter ID: {mainClaimMDModel?.SubmitterID}</p>
                                            <div className='d-flex gap-01'>
                                                {/* <button className='btn btn-enabled' onClick={() => setCardEnable(false)}>Enable</button> */}
                                                <button className='btn btn-orange za-enable ' onClick={() => setShow(false)}>View Details <i className='icon-icon-arrow-top-right'></i></button>
                                                {/* <button className='btn btn-orange btn-viewdetail ' onClick={() => setShow(false)}>View Details <i className='icon-icon-arrow-top-right'></i></button> */}
                                            </div>

                                        </div>
                                        <div className='w-100'>
                                            <div className="d-flex justify-content-between align-items-center br-bottom-1 br-clr-e0e0e0 pb-1 mb-2 ">
                                                <p className='heading fs-13'>Features</p>
                                                {/* <button className="btn btn-orange btn-viewdetail" onClick={handleSaveClaimMD} >Save</button> */}
                                                {/* <i className="icon-Group-482289" ></i>x  */}

                                                <div className="app_tooltip left">
                                                    <i className="icon-Vector5" onClick={handleSaveClaimMD}></i>
                                                    <p class="tool_tip xsm_text text-light">Save</p>
                                                </div>
                                            </div>

                                            <div className='d-flex gap-2 '>
                                                <div className='d-flex gap-1 align-items-center '>
                                                    <div className="custom_check_box">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input p-0"
                                                            name='Professional'
                                                            id='Professional'
                                                            checked={mainClaimMDModel?.Professional}
                                                            onChange={handleClaimMD}
                                                        />
                                                    </div>
                                                    <p className='text fs-12 text-nowrap'>Professional Claims</p>
                                                </div>
                                                <div className='d-flex gap-1 align-items-center '>
                                                    <div className="custom_check_box">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input p-0"
                                                            name='Institutional'
                                                            id='Institutional'
                                                            checked={mainClaimMDModel?.Institutional}
                                                            onChange={handleClaimMD}
                                                        />
                                                    </div>
                                                    <p className='text fs-12 text-nowrap'>Institutional Claims</p>
                                                </div>


                                            </div>
                                            <div className='d-flex gap-74 mb-15'>
                                                <div className='d-flex gap-1 align-items-center '>
                                                    <div className="custom_check_box">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input p-0"
                                                            name='Eligibility'
                                                            id='Eligibility'
                                                            checked={mainClaimMDModel?.Eligibility}
                                                            onChange={handleClaimMD}
                                                        />
                                                    </div>
                                                    <p className='text fs-12  text-nowrap'>Eligibility</p>
                                                </div>
                                                <div className='d-flex gap-1 align-items-center '>
                                                    <div className="custom_check_box">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input p-0"
                                                            name='ClaimStaus'
                                                            id='ClaimStaus'
                                                            checked={mainClaimMDModel?.ClaimStaus}
                                                            onChange={handleClaimMD}
                                                        />
                                                    </div>
                                                    <p className='text fs-12  text-nowrap'>Claim Status</p>
                                                </div>


                                            </div>
                                            <p className='heading fs-13 pb-1 mb-2 br-bottom-1 br-clr-e0e0e0'>Account Type:</p>
                                            <div className="input">
                                                <SuperSearchList
                                                    type="client"
                                                    id='AccountType'
                                                    name='AccountType'
                                                    searchValue={mainClaimMDModel?.AccountType}
                                                    data={AccountTypeDD}
                                                    onChange={handleSuperSearchChange}
                                                    getSelectedData={handleSelectedData}
                                                    // disabled={true}
                                                    isReadOnly={disabled ? true : false}
                                                    ScrollOutside={true}
                                                    // is={is}
                                                    icon={'Simple'}
                                                    sup_btn='sup_btn-Inp'
                                                    sup_inp='superSearchVisitInp'
                                                />
                                            </div>


                                            {/* <div className="d-flex gap-2">
                                                <div className="ar_radio-btn d-flex align-items-center gap-1">
                                                    <input
                                                        type="radio"
                                                        id="StarAccount"
                                                        name="AccountType"
                                                        checked={mainClaimMDModel?.AccountType === 'StarAccount'}
                                                        value="StarAccount"
                                                        onChange={handleClaimMD}
                                                        disabled={disabled ? true : false}

                                                    />
                                                    <label htmlFor="StarAccount" className="text fs-12 ar-orange-text">
                                                        STAR
                                                    </label>
                                                </div>
                                                <div className="ar_radio-btn d-flex align-items-center gap-1">
                                                    <input
                                                        type="radio"
                                                        id="SCFAAccount"
                                                        name="AccountType"
                                                        checked={mainClaimMDModel?.AccountType === 'SCFAAccount'}
                                                        value="SCFAAccount"
                                                        onChange={handleClaimMD}
                                                        disabled={disabled ? true : false}
                                                    />
                                                    <label htmlFor="SCFAAccount" className="text fs-12 ar-orange-text">
                                                        SCFA
                                                    </label>
                                                </div>
                                            
                                            </div> */}
                                        </div>

                                    </div>
                                </div>


                            </>
                        )


                        :
                        (<>
                            <div div className='d-flex gap-40 flex-wrap submiterCard' >
                                <div className='za-Claim-MD billing_to-do-list d-flex gap-20'>
                                    <div className='d-flex flex-column align-items-center '>
                                        <div className="mb-2  img-container s-60">
                                            <img src={CMD} />
                                        </div>
                                        <p className='heading fs-14 mb-06-px text-center'>Claim MD</p>
                                        <p className='text font-m fs-12 fst-italic text-center ar-border-color mb-06-px'>Submitter ID: N/A</p>
                                        <button className='btn btn-orange za-enable' onClick={() => setCardEnable(true)}>Enable</button>
                                    </div>

                                    <div className='w-100'>
                                        <p className='heading fs-13 pb-1 mb-2 br-bottom-1 br-clr-e0e0e0'>Features</p>
                                        <div className='d-flex gap-2 mb-2 todo-content'>
                                            <p className='text fs-12 ar-dot text-nowrap'>Professional Claims</p>
                                            <p className='text fs-12 ar-dot text-nowrap'>Institutional Claims</p>
                                        </div>
                                        <div className='d-flex gap-74 mb-15 todo-content'>
                                            <p className='text fs-12 ar-dot text-nowrap'>Eligibility</p>
                                            <p className='text fs-12 ar-dot text-nowrap'>Claim Status</p>
                                        </div>
                                        <p className='heading fs-13 pb-1 mb-2 br-bottom-1 br-clr-e0e0e0'>Account Type:</p>
                                        <p className='text fs-12'>Configure your clearinghouse</p>
                                    </div>

                                </div>
                            </div>
                        </>
                        )
                    }
                </>
            )

                : (
                    <Table
                        columns={columns}
                        rows={SubmitterData}
                        height='500px'
                        rowClass={rowClass}
                        // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                        dynamicClass='fill-grid DataGrid-Table hk-exp-table insurance_code_table'
                        rowHeight={25}
                        PerPage={PerPage}
                        PageNo={PageNo}
                        TotalPages={TotalPages}
                        handlePageClick={handlePageClick}
                        PreviousPage={PreviousPage}
                        handleFingByCreteria={handleFingByCreteria}
                        NextPage={NextPage}
                        Key={624}
                        Name={'Submitter'}
                        isLoading={isLoading}
                        TableName={'SubmitterReceiver'}
                        handleSelectData={handleSelectData}
                        LoadData={() => LoadData(searchParam)}
                        ClearSearch={handleClearSearch}
                    />
                )
            }
        </>)
    }
    // useEffect(()=>{
    //     if(type && type === "Wizard"){
    //         if(SubmitterData?.length == 0 && isNull(searchParamType)){
    //             setIsOpenSubmitter(true)
    //         }
    //     }
    // },[SubmitterData, searchParamType])
    return (
        <>
            {/* {PopupScreen} */}
            {isLoading ? <Loader /> : null}
            {type && type === "Wizard" ?
                <>
                    {/* {SubmitterData?.length > 0 || !isNull(searchParamType) ? */}
                    <>
                        {IsOpenSubmitter ? <>{PopupScreen}</> : IsOpenClearHo ? <>{PopupScreenClearHO}</> : <>{SubmitterBody()}</>}
                    </>
                    {/* : <>{PopupScreen}</> */}
                    {/* } */}
                </> :
                <>
                    {PopupScreen}
                    {PopupScreenClearHO}
                    {SubmitterBody()}
                </>
            }

        </>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer,
    }
}
export default connect(mapStateToProps)(Submitter)